module.exports = __webpack_public_path__ + "static/media/PriceProfile.b2e046db.svg";